'use strict';

import uiRouter from '@uirouter/angularjs';
import pandoraAuth from '@dwp/auth';

import { AuthBehaviorProviderService } from './mx-auth-behavior-provider-service';
import { authorizationInterceptor } from './authorizationInterceptor';
import { AuthenticationService } from './mx-authentication-service';
import { clearFailedAttempts } from '../Login/utils.login';

export const authModule = angular
	.module('mx.sb.auth', [uiRouter, pandoraAuth])
	.service('mx.shell.AuthBehaviorProviderService', AuthBehaviorProviderService)
	.factory('mx.shell.AuthorizationInterceptor', authorizationInterceptor)
	.service('mx.shell.AuthService', AuthenticationService)
	.config(configAuthModule)
	.run(runAuthModule);

configAuthModule.$inject = ['$transitionsProvider'];
function configAuthModule($transitions) {
	let requiresAuthCriteria = {
		to: (state) => !state.data || (state.data && !state.data.isAnonymous),
	};
	let redirectToLogin = async (transition) => {
		const authService = transition.injector().get('mx.shell.AuthService');

		if (!(await authService.isAuthenticated())) {
			try {
				await authService.login();
				clearFailedAttempts();
			} catch (e) {
				authService.logout();
				return false;
			}
		}
	};
	$transitions.onBefore(requiresAuthCriteria, redirectToLogin, { priority: 100 });
}

runAuthModule.$inject = ['mx.app.HttpInterceptorsRegistry', 'mx.shell.AuthorizationInterceptor'];
function runAuthModule(httpInterceptorsRegistry, authorizationInterceptor) {
	httpInterceptorsRegistry.register(authorizationInterceptor);
}
